export default {"src":"/_next/static/media/icone-aura.12e6418c.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};